module.exports = __webpack_public_path__ + "Icono_Encuestas_512px.png";